import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation logInUser($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      user {
        id
        fullName
        email
        ucasNumber
        universityEmail
        completedMarketing
        allowMarketing
        universityEmailVerified
        yearOfStudy
        subjectOfStudy {
          id
          name
        }
        university {
          id
          name
        }
        createdAt
        userType
        avatar {
          id
          sizes {
            small {
              url
            }
            medium {
              url
            }
          }
        }
        referralUrl
      }
      expiresAt
      token
    }
  }
`

export interface LogInInput {
  email: string
  password: string
}

export interface LogInOutput {
  login: {
    user: {
      id: string
      fullName: string
      email: string
      ucasNumber: string
      universityEmail: string
      completedMarketing: boolean
      allowMarketing: boolean
      universityEmailVerified: boolean
      yearOfStudy: number
      subjectOfStudy: {
        id: string
        name: string
      }
      university: {
        id: string
        name: string
      }
      createdAt: string
      userType: string
      avatar: {
        id: string
        sizes: {
          small: {
            url: string
          }
          medium: {
            url: string
          }
        }
      }
      referralUrl?: string
    }
    expiresAt: string
    token: string
  }
}

export const useLogIn = () => useMutation<LogInOutput, LogInInput>(mutation)
